import Button from 'components/Button';
import {forwardRef, ReactNode} from 'react';
import {useFormContext} from 'react-hook-form';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

import useFormEmpty from '../hooks/useFormEmpty';

type FilterByMenuContainerProps = {
    children: ReactNode;
    className?: string;
    resettableFilters: string[];
    title: string;
};

const FilterByMenuContainer = forwardRef<
    HTMLDivElement,
    FilterByMenuContainerProps
>(({children, className, resettableFilters, title}, ref) => {
    const {setValue} = useFormContext();

    const show = useFormEmpty(resettableFilters);

    const handleReset = () => {
        resettableFilters.forEach((filter) => {
            // Tried only with resetField but doesn't seem to properly work on certain fields (dates)...
            setValue(filter, null);
        });
    };

    return (
        children && (
            <div
                className={twMerge(
                    'pointer-events-auto my-2 grid w-[25rem] min-w-fit grid-cols-1 rounded border border-grey-400 bg-grey-10 drop-shadow-md gap-x-4',
                    className,
                )}
                ref={ref}
            >
                <header className="flex justify-between rounded-t border-b border-b-grey-400 bg-grey-100 px-4 py-2 font-semibold">
                    {title}
                    {show && (
                        <Button
                            kind="secondary"
                            onClick={() => handleReset()}
                            size="xs"
                        >{t`Clear Filters`}</Button>
                    )}
                </header>
                <div className="px-4 py-2">{children}</div>
            </div>
        )
    );
});

FilterByMenuContainer.displayName = 'FilterByMenuContainer';

export default FilterByMenuContainer;
